import PropTypes from "prop-types";
import DropdownWithMultiCtrlledRemovable from "@shared/DropdownWithMultiCtrlledRemovable";

const ExcludeTagFilter = ({ tags, excludedTags }) => (
  <DropdownWithMultiCtrlledRemovable
    isVirtualized
    options={tags.map(({ id: value, name: label }) => ({ label, value: `${value}` }))}
    selectedOptions={excludedTags
      ?.map((excludedId) => tags.find((t) => t.id === excludedId))
      // Drop ids whose tag no longer exists (e.g. deleted since the filter was
      // saved); otherwise destructuring undefined here crashes the whole control
      // and the exclude-tags filter silently disappears on reload.
      .filter(Boolean)
      .map(({ id, name }) => ({ label: name, value: `${id}` }))}
    removablePrefix={`Tag (Exclude): `}
    placeHolderTxt=" excluded tags selected"
    ctrlName="leads_filter[selected_exclude_tag_filters][]"
  />
);

ExcludeTagFilter.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  excludedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ExcludeTagFilter;
